import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ReferenceLine } from 'recharts';

interface Bar {
  name: string;
  est_pnl_pct: number;
}

interface Props {
  data: Bar[];
}

const colorFor = (n: number): string => {
  if (n <= -20) return '#ef4444';
  if (n <= -5)  return '#f59e0b';
  if (n >= 5)   return '#22c55e';
  return '#94a3b8';
};

const ScenarioBars: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="chart-empty">No scenario data.</div>;
  }
  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height={195}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 8, right: 20, left: 8, bottom: 8 }}
        >
          <XAxis
            type="number"
            tick={{ fill: '#94a3b8', fontSize: 10 }}
            tickFormatter={(v) => `${v}%`}
          />
          <YAxis
            type="category"
            dataKey="name"
            tick={{ fill: '#cbd5e1', fontSize: 11 }}
            width={110}
          />
          <ReferenceLine x={0} stroke="#475569" />
          <Tooltip
            contentStyle={{ background: '#0f172a', border: '1px solid #334155', borderRadius: 4, fontSize: 12 }}
            formatter={(v: any) => [`${Number(v).toFixed(2)}%`, 'Est P&L']}
          />
          <Bar dataKey="est_pnl_pct" radius={[0, 3, 3, 0]}>
            {data.map((d, i) => (
              <Cell key={i} fill={colorFor(d.est_pnl_pct)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ScenarioBars;
